const frenchEurosFormat = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
})

export const centsToEuros = (cents: number) => parseFloat((cents / 100).toFixed(2))

const centsToKEuros = (cents: number) => parseFloat((cents / 100000).toFixed(1))

export const centsToEurosFormatted = (cents: number) => frenchEurosFormat.format(centsToEuros(cents))
